import React from 'react'
import { FormAnswerCheckbox } from './FormAnswerCheckbox'
import { FormAnswerDate } from './FormAnswerDate'
import { FormIdeaQuestion, FormIdeaAnswer, AnswerLink } from './styles'
import { FormAnswerUpload } from './FormAnswerUpload'
import { FormAnswerProps } from './contracts'
import {FormAnswerLink} from "./FormAnswerLink";
import DOMPurify from "dompurify";


export const checkJSON = (answer: any): JSX.Element => {
  try {
    const answerJSON = JSON.parse(answer.value)
    if (answerJSON === null || typeof answerJSON !== 'object') {
      throw new Error()
    }
    const answersArray = Object.values(answerJSON)
    return (
    <>
      {answersArray.map((answerValue: any) => {
        return <FormIdeaAnswer>{answerValue}</FormIdeaAnswer>
      })}
    </>)
  } catch (exception) {
    if (answer.value === '' && answer.archive !== null) {
      return <FormAnswerUpload answer={answer} />
    } else {
      if (checkUrl(answer.value)) {
        return <AnswerLink href={answer.value} target="_blank"><FormIdeaAnswer>{answer.value}</FormIdeaAnswer></AnswerLink>
      } else {
        return <FormIdeaAnswer><div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(answer.value).replace(/\n/g, '<br />') }} /></FormIdeaAnswer>
      }
    }
  }
}

const checkUrl = (answer: string): boolean => {
  try {
    const url = new URL(answer)
    return true
  } catch (err) {
    return false
  }
}

const getQuestionType = (answer: any): JSX.Element => {
  switch (answer.questionType) {
    case 'checkbox-group':
      return <FormAnswerCheckbox answer={answer} />
    case 'date':
      return <FormAnswerDate answer={answer} />
    case 'upload':
      return <FormAnswerUpload answer={answer} />
    case 'url':
      return <FormAnswerLink answer={answer} />
    default:
      return (
        <>
          {checkJSON(answer)}
        </>
      )
  }
}

export const FormAnswer = ({ answer }: FormAnswerProps): JSX.Element => {
  if (answer == null) return <></>
  return (
    <div className="mb-3">
      <FormIdeaQuestion>{answer.question}</FormIdeaQuestion>
      {getQuestionType(answer)}
    </div>
  )
}
